<script>
import { Pie } from 'vue-chartjs';
import { apiGetItemClassGroupData } from '@/api/statistics/statistics.js';
import { toCurrency, commaSeparated } from '@/utils/etc.js';

export default {
	extends: Pie,
	props: {
		from_date: String,
		to_date: String,
		sort_key: String,
		sales_team: String,
	},
	async mounted() {
		const { data } = await apiGetItemClassGroupData(this.from_date, this.to_date, this.sort_key, this.sales_team);
		let item_class_group_data = [];
		let labels = [];
		let total_qty = 0;
		let total_amt = 0;
		data.forEach(el => {
			total_qty += el.cg_quantity;
			total_amt += el.cg_amount;
			item_class_group_data.push(this.sort_key === 'amount' ? el.cg_amount : el.cg_quantity);
			labels.push(el.cg_name);
		});
		let backgroundColor = this.$colorListForChart;

		if (backgroundColor.length < data.length) {
			for (let i = 0; i < data.length - backgroundColor.length; i++) {
				let r = Math.floor(Math.random() * 255);
				let g = Math.floor(Math.random() * 255);
				let b = Math.floor(Math.random() * 255);

				backgroundColor.push('rgba(' + r + ',' + g + ',' + b + ',0.8)');
			}
		}

		let hovering = false; // legend hover여부
		let custom_tooltip = document.querySelector('#custom_graph_tooltip'); // 레전드 hover시 보여줄 tooltip
		let sort_key = this.sort_key;

		this.renderChart(
			{
				labels,
				datasets: [
					{
						data: item_class_group_data,
						backgroundColor: backgroundColor,
					},
				],
			},
			{
				hoverBorderWidth: 20,
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					position: 'right',
					onHover: function(event, legendItem) {
						if (hovering) return;

						hovering = true;
						let item = data[legendItem.index];
						let charDOMRect = this.chart.ctx.canvas.getBoundingClientRect(); // document.documentElement.scrollTop;
						let legendHitBox = this.chart.legend.legendHitBoxes[legendItem.index];
						let qty_msg = `QTY: ${commaSeparated(item.cg_quantity)}`;
						let amt_msg = `AMT: ${toCurrency(item.cg_amount)}`;
						let percentage = `PER: ${toCurrency((sort_key === 'amount' ? item.cg_amount / total_amt : item.cg_quantity / total_qty) * 100)}%`;
						custom_tooltip.innerHTML = (sort_key === 'amount' ? amt_msg + '<br />' + qty_msg : qty_msg + '<br />' + amt_msg) + '<br />' + percentage;
						custom_tooltip.style.left = document.documentElement.scrollLeft + charDOMRect.left + legendHitBox.left + legendHitBox.width + 5 + 'px';
						custom_tooltip.style.top = document.documentElement.scrollTop + charDOMRect.top + legendHitBox.top + 'px';
						custom_tooltip.style.display = 'block';
					},
					onLeave: () => {
						hovering = false;
						custom_tooltip.innerHTML = '';
						custom_tooltip.style.display = 'none';
					},
				},
				// animation: {
				// 	duration: 3000,
				// },
				tooltips: {
					mode: 'nearest',
					intersect: true,
					callbacks: {
						title: function(tooltipItemList, data) {
							// let title = null;
							// let datasetIndex = tooltipItemList[0].datasetIndex; // 0: Average Amount, 1: Amount By Sales Group
							// if (datasetIndex === 0) title = data['datasets'][0]['label'];
							// else title = data['labels'][tooltipItemList[0]['index']];

							return data['labels'][tooltipItemList[0]['index']];
						},
						label: function(tooltipItem, data) {
							// let datasetIndex = tooltipItem.datasetIndex; // 0: Average Amount, 1: Amount By Sales Group
							let label = data['datasets'][0]['data'][tooltipItem['index']];
							return sort_key === 'amount' ? toCurrency(label) : commaSeparated(label);
						},
					},
					backgroundColor: '#C4D5FF',
					titleFontSize: 12,
					titleFontColor: '#0066ff',
					bodyFontColor: '#000',
					bodyFontSize: 12,
					displayColors: true,
				},
				plugins: {
					datalabels: {
						display: true,
						align: 'start',
						anchor: 'end',
						font: { size: 11 },
						formatter: function(value, ctx) {
							let percent = (ctx.dataset.data[ctx.dataIndex] / (sort_key === 'amount' ? total_amt : total_qty)) * 100;
							return percent > 4 ? toCurrency(percent) + '%' : null;
						},
						color: function() {
							return 'white';
						},
					},
				},
			},
		);

		this.$emit('emitSumData', { 'Total QTY': total_qty, 'Total AMT': total_amt });

		this.$nextTick(() => {
			this.$refs.canvas.style.height = '300px';
		});
	},
};
</script>

<style></style>
